import { Component } from '@angular/core';
import { CerSessionService } from 'src/cer/cer-session/cer-session.service';

@Component({
  selector: 'cer-logoff',
  template: '<h3>Logoff</h3>'
})
export class CerLogoffComponent {

  constructor(private sessionService: CerSessionService) { 
      this.sessionService.deactivate();
    }

}
